var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTriangleRight = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 9,
  height: 11,
  fill: "none",
  viewBox: "0 0 9 11"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "url(#a)",
  d: "m0 11 9-5.5L0 0z"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "a",
  x1: 9,
  x2: 0,
  y1: 5.5,
  y2: 5.5,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#008129"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.01,
  stopColor: "#008228"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.43,
  stopColor: "#00A312"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.77,
  stopColor: "#00B704"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#00BF00"
})))));
export { SvgTriangleRight as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI5IiBoZWlnaHQ9IjExIiB2aWV3Qm94PSIwIDAgOSAxMSIgZmlsbD0ibm9uZSI+CiAgPHBhdGggZD0iTTMuMDUxNzZlLTA1IDExTDkuMDAwMDMgNS41TDMuMDUxNzZlLTA1IDBWMTFaIiBmaWxsPSJ1cmwoI3BhaW50MF9saW5lYXJfMl80NTIpIi8+CiAgPGRlZnM+CiAgICA8bGluZWFyR3JhZGllbnQgaWQ9InBhaW50MF9saW5lYXJfMl80NTIiIHgxPSI5LjAwMDAzIiB5MT0iNS41IiB4Mj0iMy4wNTE3NmUtMDUiIHkyPSI1LjUiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj4KICAgICAgPHN0b3Agc3RvcC1jb2xvcj0iIzAwODEyOSIvPgogICAgICA8c3RvcCBvZmZzZXQ9IjAuMDEiIHN0b3AtY29sb3I9IiMwMDgyMjgiLz4KICAgICAgPHN0b3Agb2Zmc2V0PSIwLjQzIiBzdG9wLWNvbG9yPSIjMDBBMzEyIi8+CiAgICAgIDxzdG9wIG9mZnNldD0iMC43NyIgc3RvcC1jb2xvcj0iIzAwQjcwNCIvPgogICAgICA8c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiMwMEJGMDAiLz4KICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgPC9kZWZzPgo8L3N2Zz4=";